module.exports = __webpack_public_path__ + "img/steppi-pro-2.c7f9a842.png";